module.exports = __webpack_public_path__ + "static/media/35.9ff0178f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/35.jpg
// module id = 404
// module chunks = 0